// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"c3b7b9f0","532":"382a8bef","600":"45fd38e5","732":"afb73b47","744":"141e394c"}[chunkId] + ".chunk.js";
};